"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatesitechangerequest = exports.listsupportingdocuments = exports.saverejection = exports.saveapproval = exports.list = void 0;
const permissions_1 = require("shared/permissions");
const endpoint_1 = require("api/endpoint");
exports.list = endpoint_1.createEndpoint()({
    method: "get",
    path: "assetapprovals/list",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.saveapproval = endpoint_1.createEndpoint()({
    method: "put",
    path: "assetapprovals/saveapproval",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.saverejection = endpoint_1.createEndpoint()({
    method: "put",
    path: "assetapprovals/saverejection",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.listsupportingdocuments = endpoint_1.createEndpoint()({
    method: "get",
    path: "assetapprovals/listsupportingdocuments",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updatesitechangerequest = endpoint_1.createEndpoint()({
    method: "post",
    path: "assetapprovals/updatesitechangerequest",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});



//////////////////
// WEBPACK FOOTER
// ./src/api/asset-approvals/asset-approvals-client.ts
// module id = 979
// module chunks = 0 1 2